import { Component, Input, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { ReferralData, ReferralDataItem, ReferralDataSection } from 'app/shared/models/referral';
@Component({
  selector: 'referral-data-widget',
  templateUrl: './referral-data-widget.component.html',
  styleUrls: ['./referral-data-widget.component.scss'],
  animations: fuseAnimations,
})

export class ReferralDataWidgetComponent implements OnInit {

  data: ReferralData;
  hasSections = false;

  @Input() jsonData: any;

  ngOnInit(): void {
    if (this.jsonData) {
      this.data = this.jsonData as ReferralData;
      this.hasSections = (this.data.data.length > 0) && (this.data.data[0] as any).section && ((this.data.data[0] as any).section.fields.length > 0);
    }
  }
}
